(() => {
  const root = document.querySelector('[data-emu-contact-cta]');
  if (!root) return;

  const main = document.querySelector('#MainContent');
  const legacyLineSection =
    document.querySelector('[id$="__16550108476452c177"]') ||
    [...document.querySelectorAll('h1,h2,h3')]
      .find((heading) => heading.textContent.trim() === 'LINE友だち募集中！')
      ?.closest('.shopify-section');

  if (main && legacyLineSection && root.parentElement !== main) {
    main.insertBefore(root, legacyLineSection);
  }

  if (legacyLineSection) {
    legacyLineSection.hidden = true;
  }

  root.hidden = false;
})();
